import Lighting from '../../../base/menu/airdome/Lighting';

const lighting: Lighting = {
  categoryName: 'Osvětlení',
  current: 'Aktuální'
};

export default lighting;
